import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { R2PhotoGallery } from '../components/trip/R2PhotoGallery';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { PageHeader } from '../components/common/PageHeader';
import { Button } from '../components/ui/button';
import { Plus } from 'lucide-react';

export default function TripGallery() {
  const { tripId } = useParams();
  const context = useOutletContext();
  const { isOrganizer } = context || {};
  const { api } = useAuth();
  const { t } = useLanguage();
  const [itineraryItems, setItineraryItems] = useState([]);
  const openUploadRef = useRef(null);

  useEffect(() => {
    const fetchItineraryItems = async () => {
      try {
        const response = await api.get(`/trips/${tripId}/itinerary/items`);
        setItineraryItems(response.data);
      } catch (error) {
        console.error('Error fetching itinerary items:', error);
      }
    };
    
    if (tripId && api) {
      fetchItineraryItems();
    }
  }, [tripId, api]);

  const handleOpenUpload = useCallback((openFn) => {
    openUploadRef.current = openFn;
  }, []);

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('gallery.title')}
        subtitle={t('gallery.subtitle')}
        helpScreen="gallery"
        actions={
          <Button 
            className="rounded-full bg-orange-500 hover:bg-orange-600" 
            data-testid="upload-photo-btn"
            onClick={() => openUploadRef.current?.()}
          >
            <Plus className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">{t('gallery.uploadPhotos')}</span>
            <span className="sm:hidden">{t('gallery.upload')}</span>
          </Button>
        }
      />
      
      <R2PhotoGallery 
        tripId={tripId} 
        itineraryItems={itineraryItems}
        isOrganizer={isOrganizer}
        hideHeader={true}
        onOpenUpload={handleOpenUpload}
      />
    </div>
  );
}
